import { useEffect, useMemo } from 'react';
import { Suspense } from 'react';
import { Routes as RootRoutes, Route } from 'react-router-dom';

import NotFoundPage from './404';
import { routes } from './routes';
import { setAuthenticatedUser, setPermissions, usePermissions, useAuthenticatedUser } from '@infrastructure/authorization';
import { Permission } from '@infrastructure/authorization/constants';
import { filterPagesByPermissions } from '@router/utils';
import { apiClient } from '@api/client/index';
import { load } from '@infrastructure/loader';
import { openErrorNotification } from '@api/client/utils';

export const Pages = () => {
  const permissions = usePermissions();
  const authenticatedUser = useAuthenticatedUser();

  useEffect(() => {
    load(() => apiClient.systemAuth())
      .then((s) => {
        setAuthenticatedUser(s.userKey ?? null);
        setPermissions((s.securityTokens ?? []) as Permission[]);
      })
      .catch(() => {
        setPermissions([]);
        openErrorNotification();
      });
  }, []);

  const allowedRoutes = useMemo(
    () => (permissions === null ? [] : filterPagesByPermissions(routes, permissions, authenticatedUser !== null)),
    [permissions, authenticatedUser],
  );

  if (permissions === null) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <RootRoutes>
        {allowedRoutes.map(({ path, element }) => (
          <Route path={path} element={element} key={path} />
        ))}
        <Route path="*" element={<NotFoundPage />} />
      </RootRoutes>
    </Suspense>
  );
};
